"use strict";

var get = require('lodash.get');
var makeGetToken = function makeGetToken(_ref) {
  var refreshToken = _ref.refreshToken,
    getTokenFromCookie = _ref.getTokenFromCookie,
    isTokenExpired = _ref.isTokenExpired;
  return function (options) {
    var refetch = get(options, 'refetch');
    var token = getTokenFromCookie() || '';
    var isTokenInCookie = !!token;
    var isExpired = isTokenExpired({
      token: token
    });
    if (refetch) {
      console.debug('Forcing token refresh');
      return refreshToken(isTokenInCookie);
    }
    if (!isExpired) {
      return Promise.resolve(token);
    }
    console.debug('Empty or expired token, refreshing session');
    return refreshToken(isTokenInCookie);
  };
};
module.exports = {
  makeGetToken: makeGetToken
};